import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from './linkedservice.adapter';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from './azure-key-vault.util';
import { FabricLinkedService } from 'app/model/linkedservice/fabric-workspace.linkedservice';
import { restAuthTypes } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(FabricLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                workspaceId: '*',
                username: '*',
                userTenant: '*',
                password: 'secret',
                authenticationType: '*'
            },
            parameters: '*'
        }
    }
})

export class FabricWorkspaceLinkedServiceAdapter extends LinkedServiceAdapter<FabricLinkedService> {

    protected modelConstructor(): new () => FabricLinkedService {
        return FabricLinkedService;
    }

    protected model(): IModel {
        return FabricLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: FabricLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.FabricLinkedService;
        properties.type = Metamodel.modelFor(FabricLinkedService).name;
        properties.typeProperties = {
            workspaceId: this.valueToResource(linkedService, FabricLinkedService.WORKSPACE_ID)
        };
        if (linkedService.servicePrincipalId) {
            properties.typeProperties.servicePrincipalId = linkedService.servicePrincipalId;
            properties.typeProperties.servicePrincipalKey = passwordOrAKVtoSecretBase(linkedService.servicePrincipalKey, this.context);
            properties.typeProperties.tenant = linkedService.tenant;
            properties.typeProperties.authenticationType = restAuthTypes.AadServicePrincipal;
        } else {
            properties.typeProperties.authenticationType = restAuthTypes.ManagedServiceIdentity;
        }
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: FabricLinkedService): Promise<FabricLinkedService> {
        const properties = linkedServiceResource.properties as Model.FabricLinkedService;

        linkedService.workspaceId = properties.typeProperties.workspaceId;

        switch (properties.typeProperties.authenticationType) {
            case restAuthTypes.AadServicePrincipal:
                linkedService.authenticationType = restAuthTypes.AadServicePrincipal;
                linkedService.servicePrincipalId = properties.typeProperties.servicePrincipalId;
                linkedService.tenant = properties.typeProperties.tenant;
                linkedService.servicePrincipalKey = secretBaseToPasswordOrAKV(properties.typeProperties.servicePrincipalKey, true, this.context);
                break;
            case restAuthTypes.ManagedServiceIdentity:
                linkedService.authenticationType = restAuthTypes.ManagedServiceIdentity;
                break;
            default:
                break;
        }

        return linkedService;
    }
}
